import React, { createContext, useContext, useState, useEffect } from "react";

const LanguageContext = createContext();

export const translations = {
  ca: {
    nav: {
      facilities: "Instal·lacions",
      services: "Serveis",
      schedule: "Horari",
      pricing: "Preus",
      contact: "Contacte",
      cta: "Reserva la teva plaça",
    },
    hero: {
      overline: "Gimnàs a Vidreres · Girona",
      headline1: "Supera",
      headline2: "els teus",
      headline3: "límits.",
      sub: "Més de 80 màquines professionals, entrenadors d'elit i obertura de 5:00h a 1:00h. El teu rendiment, sense horaris.",
      cta_primary: "Apunta't ara",
      cta_secondary: "Veure instal·lacions",
    },
    marquee: ["Força", "Cardio", "Funcional", "Grup reduït", "Nutrició", "Rutines", "Entrenament personal"],
    stats: {
      title: "XPRO en xifres",
      items: [
        { val: "80+", label: "Màquines noves" },
        { val: "365", label: "Dies a l'any" },
        { val: "20h", label: "Obert cada dia" },
        { val: "100%", label: "Professional" },
      ],
    },
    facilities: {
      overline: "Instal·lacions",
      title: "Equipament d'elit",
      desc: "Un espai dissenyat per rendir. Més de 80 màquines d'última generació, zona de pes lliure, cardio premium i sala d'entrenaments en grup reduït.",
      items: [
        { tag: "Força", title: "Zona de pes lliure", desc: "Racks, barres olímpiques i discos per a tots els nivells." },
        { tag: "Cardio", title: "Cardio premium", desc: "Cintes, el·líptiques i bikes d'última generació amb pantalles." },
        { tag: "Màquines", title: "Màquines guiades", desc: "Màquines noves per treballar cada grup muscular amb seguretat." },
      ],
    },
    services: {
      overline: "Serveis",
      title: "Tot el que necessites",
      desc: "Un pla complet per assolir els teus objectius, al teu ritme i amb acompanyament real.",
      items: [
        { title: "Entrenament Personal", desc: "Sessions 1-a-1 amb el teu entrenador. Resultats reals, adaptats a tu.", icon: "UserCircle" },
        { title: "Entrenos en Grup Reduït", desc: "Entrenos en grups de màxim 6 persones. Atenció personalitzada amb l'energia del grup.", icon: "Users", soon: true },
        { title: "Nutrició Esportiva", desc: "Plans d'alimentació per guanyar múscul, perdre greix o rendir més.", icon: "Apple" },
        { title: "Rutines Personalitzades", desc: "Programació adaptada al teu nivell, horari i objectiu.", icon: "ClipboardList" },
      ],
    },
    schedule: {
      overline: "Horari",
      title: "Obert 365 dies l'any",
      desc: "De dilluns a diumenge, 5:00h a 1:00h. Sense excuses, sense festius.",
      open: "Obert",
      close: "Tanca",
      today: "Avui",
      days: [
        { d: "Dilluns", h: "05:00 — 01:00" },
        { d: "Dimarts", h: "05:00 — 01:00" },
        { d: "Dimecres", h: "05:00 — 01:00" },
        { d: "Dijous", h: "05:00 — 01:00" },
        { d: "Divendres", h: "05:00 — 01:00" },
        { d: "Dissabte", h: "05:00 — 01:00" },
        { d: "Diumenge", h: "05:00 — 01:00" },
      ],
    },
    pricing: {
      overline: "Preus",
      title: "Sense excuses",
      desc: "Tria el teu pla. Preu especial d'apertura.",
      progress_label: "Places ocupades",
      progress_label_t2: "Oferta 2 — Últimes places",
      progress_label_t3: "Oferta 3 — Últimes places",
      progress_taken: 0,
      progress_total: 100,
      founder: {
        label: "",
        plan_name: "MATRÍCULA GRATUÏTA",
        old_price: "49,90€",
        price: "49,90€",
        period: "/mes",
        features: [
          "Accés a totes les instal·lacions",
          "Obert 365 dies, 5:00h a 1:00h",
          "Sala climatitzada",
          "Assessorament inicial gratuït",
          "Sense permanència",
        ],
        cta: "Reserva la teva plaça",
        note: "",
        enrollment_label: "Matrícula gratis",
        enrollment_old: "29€",
        wa_msg: "Hola! Vull reservar una plaça a XPRO FITNESS (49,90€/mes + matrícula gratis).",
      },
      founder_t2: {
        label: "🔥 Oferta 2 — Últimes 50 places fundadores",
        plan_name: "PREU FUNDADOR · OFERTA 2",
        old_price: "49,90€",
        price: "46,90€",
        period: "/mes durant 24 mesos",
        features: [
          "Accés a totes les instal·lacions",
          "Obert 365 dies, 5:00h a 1:00h",
          "Sala climatitzada",
          "Assessorament inicial gratuït",
          "Sense permanència",
          "Preu bloquejat 24 mesos",
        ],
        cta: "Reserva la teva plaça fundadora",
        note: "Després de 24 mesos, preu normal 49,90€/mes.",
        enrollment_label: "+ Matrícula gratis",
        enrollment_old: "29€",
        wa_msg: "Hola! Vull reservar una plaça fundadora Oferta 2 a XPRO FITNESS (46,90€/mes durant 24 mesos + matrícula gratis).",
      },
      founder_t3: {
        label: "🔥 Oferta 3 — Últimes 50 places fundadores",
        plan_name: "PREU FUNDADOR · OFERTA 3",
        old_price: "49,90€",
        price: "46,90€",
        period: "/mes durant 24 mesos",
        features: [
          "Accés a totes les instal·lacions",
          "Obert 365 dies, 5:00h a 1:00h",
          "Sala climatitzada",
          "Assessorament inicial gratuït",
          "Sense permanència",
          "Preu bloquejat 24 mesos",
        ],
        cta: "Reserva la teva plaça fundadora",
        note: "Després de 24 mesos, preu normal 49,90€/mes.",
        enrollment_label: "+ Matrícula gratis",
        enrollment_old: "29€",
        wa_msg: "Hola! Vull reservar una plaça fundadora Oferta 3 a XPRO FITNESS (46,90€/mes durant 24 mesos + matrícula gratis).",
      },
      standard: {
        label: "Quota estàndard",
        plan_name: "QUOTA XPRO",
        price: "49,90€",
        period: "/mes",
        features: [
          "Accés a totes les instal·lacions",
          "Obert 365 dies, 5:00h a 1:00h",
          "Sala climatitzada",
          "Assessorament inicial gratuït",
          "Sense permanència",
        ],
        cta: "Reserva la teva plaça",
      },
    },
    testimonials: {
      overline: "Comunitat XPRO",
      title: "El que diuen els nostres socis",
      items: [
        { name: "Marc P.", role: "Soci fundador", text: "Les màquines són impecables i els entrenadors de primer nivell. El millor gimnàs de Vidreres, de llarg." },
        { name: "Laia F.", role: "Grup reduït", text: "M'encanten els entrenos en grup reduït. Atenció personalitzada i amb una energia brutal." },
        { name: "Jordi M.", role: "Entrenament personal", text: "Amb el pla personal he guanyat 6 kg de múscul en 4 mesos. Gent molt professional." },
      ],
    },
    location: {
      overline: "On som",
      title: "Vine a conèixer-nos",
      desc: "Et convidem a una visita gratuïta. Et mostrem les instal·lacions sense compromís.",
      address_line1: "Carrer Sils, 17",
      address_line2: "17411 Vidreres, Girona",
      phone: "+34 972 00 00 00 [PENDENT]",
      email: "hola@xprofitness.es",
      hours: "Dl — Dg · 05:00 — 01:00 · 365 dies",
      cta: "Escriu-nos per WhatsApp",
    },
    faq: {
      overline: "Preguntes",
      title: "Dubtes freqüents",
      items: [
        { q: "Hi ha permanència?", a: "No. La quota és mensual, pots donar-te de baixa quan vulguis." },
        { q: "Puc provar el gimnàs abans d'apuntar-me?", a: "Sí. Vine a visitar-nos sense compromís i et mostrem les instal·lacions." },
        { q: "Hi ha entrenador inclòs?", a: "La quota inclou assessorament inicial. L'entrenament personal 1-a-1 és un servei addicional." },
        { q: "Quins horaris teniu?", a: "Obrim tots els dies de 5:00 a 1:00, 365 dies l'any. Inclosos caps de setmana i festius." },
        { q: "Què són els entrenos en grup reduït?", a: "Sessions amb un màxim de 6 persones, dirigides per un entrenador. Tens l'energia del grup amb atenció personalitzada." },
      ],
    },
    footer: {
      tagline: "El teu gimnàs a Vidreres.",
      rights: "Tots els drets reservats.",
      links: "Enllaços",
      legal: "Legal",
      terms: "Condicions",
      privacy: "Privacitat",
      cookies: "Cookies",
      follow: "Segueix-nos",
    },
    whatsapp_msg: "Hola! M'agradaria reservar una plaça a XPRO FITNESS.",
    appDownload: {
      title: "Ja tenim App!",
      subtitle: "Descarrega l'app de XPROFITNESS i accedeix al gimnàs, contracta serveis i gestiona el teu pla des del mòbil. Fes clic a qualsevol dels dos enllaços per descarregar-la.",
    },
    banner: "Ja estem oberts · De 5:00h a 1:00h · 365 dies l'any · Sense festius",
    reserve: {
      title: "Reserva la teva plaça",
      subtitle: "Plaça limitada · Matrícula gratis · Sense permanència",
      first_name: "Nom",
      last_name: "Cognoms",
      email: "Email",
      phone: "Telèfon",
      dni: "DNI / NIE",
      birth_date: "Data de naixement",
      comments: "Comentaris (opcional)",
      accept_terms: "Accepto les condicions i la política de privacitat",
      submit: "Reservar la meva plaça",
      submitting: "Enviant...",
      success_title: "Plaça reservada!",
      success_text: (n) => `La teva plaça #${n} està reservada. Ens posarem en contacte aviat.`,
      success_cta: "Tancar",
      full_title: "Places esgotades",
      full_text: "No queden places disponibles. Contacta'ns per WhatsApp.",
      placeholders: {
        first_name: "Joan",
        last_name: "Garcia Pérez",
        email: "joan@exemple.cat",
        phone: "+34 600 000 000",
        dni: "12345678X",
        comments: "Alguna pregunta o necessitat especial?",
      },
      errors: {
        required: "Aquest camp és obligatori",
        email: "Email no vàlid",
        phone: "Telèfon no vàlid",
        dni: "DNI / NIE no vàlid",
        terms: "Has d'acceptar les condicions",
      },
    },
  },
  es: {
    nav: {
      facilities: "Instalaciones",
      services: "Servicios",
      schedule: "Horario",
      pricing: "Precios",
      contact: "Contacto",
      cta: "Reserva tu plaza",
    },
    hero: {
      overline: "Gimnasio en Vidreres · Girona",
      headline1: "Supera",
      headline2: "tus",
      headline3: "límites.",
      sub: "Más de 80 máquinas profesionales, entrenadores de élite y abierto de 5:00h a 1:00h. Tu rendimiento, sin horarios.",
      cta_primary: "Apúntate ya",
      cta_secondary: "Ver instalaciones",
    },
    marquee: ["Fuerza", "Cardio", "Funcional", "Grupo reducido", "Nutrición", "Rutinas", "Entrenamiento personal"],
    stats: {
      title: "XPRO en cifras",
      items: [
        { val: "80+", label: "Máquinas nuevas" },
        { val: "365", label: "Días al año" },
        { val: "20h", label: "Abierto cada día" },
        { val: "100%", label: "Profesional" },
      ],
    },
    facilities: {
      overline: "Instalaciones",
      title: "Equipamiento de élite",
      desc: "Un espacio diseñado para rendir. Más de 80 máquinas de última generación, zona de peso libre, cardio premium y sala de entrenos en grupo reducido.",
      items: [
        { tag: "Fuerza", title: "Zona de peso libre", desc: "Racks, barras olímpicas y discos para todos los niveles." },
        { tag: "Cardio", title: "Cardio premium", desc: "Cintas, elípticas y bikes de última generación con pantallas." },
        { tag: "Máquinas", title: "Máquinas guiadas", desc: "Máquinas nuevas para trabajar cada grupo muscular con seguridad." },
      ],
    },
    services: {
      overline: "Servicios",
      title: "Todo lo que necesitas",
      desc: "Un plan completo para alcanzar tus objetivos, a tu ritmo y con acompañamiento real.",
      items: [
        { title: "Entrenamiento Personal", desc: "Sesiones 1-a-1 con tu entrenador. Resultados reales, adaptados a ti.", icon: "UserCircle" },
        { title: "Entrenos en Grupo Reducido", desc: "Entrenos en grupos de máximo 6 personas. Atención personalizada con la energía del grupo.", icon: "Users", soon: true },
        { title: "Nutrición Deportiva", desc: "Planes de alimentación para ganar músculo, perder grasa o rendir más.", icon: "Apple" },
        { title: "Rutinas Personalizadas", desc: "Programación adaptada a tu nivel, horario y objetivo.", icon: "ClipboardList" },
      ],
    },
    schedule: {
      overline: "Horario",
      title: "Abierto 365 días al año",
      desc: "De lunes a domingo, 5:00h a 1:00h. Sin excusas, sin festivos.",
      open: "Abre",
      close: "Cierra",
      today: "Hoy",
      days: [
        { d: "Lunes", h: "05:00 — 01:00" },
        { d: "Martes", h: "05:00 — 01:00" },
        { d: "Miércoles", h: "05:00 — 01:00" },
        { d: "Jueves", h: "05:00 — 01:00" },
        { d: "Viernes", h: "05:00 — 01:00" },
        { d: "Sábado", h: "05:00 — 01:00" },
        { d: "Domingo", h: "05:00 — 01:00" },
      ],
    },
    pricing: {
      overline: "Precios",
      title: "Sin excusas",
      desc: "Elige tu plan. Precio especial de apertura.",
      progress_label: "Plazas ocupadas",
      progress_label_t2: "Oferta 2 — Últimas plazas",
      progress_label_t3: "Oferta 3 — Últimas plazas",
      progress_taken: 0,
      progress_total: 100,
      founder: {
        label: "",
        plan_name: "MATRÍCULA GRATUITA",
        old_price: "49,90€",
        price: "49,90€",
        period: "/mes",
        features: [
          "Acceso a todas las instalaciones",
          "Abierto 365 días, 5:00h a 1:00h",
          "Sala climatizada",
          "Asesoramiento inicial gratuito",
          "Sin permanencia",
        ],
        cta: "Reserva tu plaza",
        note: "",
        enrollment_label: "Matrícula gratis",
        enrollment_old: "29€",
        wa_msg: "¡Hola! Quiero reservar una plaza en XPRO FITNESS (49,90€/mes + matrícula gratis).",
      },
      founder_t2: {
        label: "🔥 Oferta 2 — Últimas 50 plazas fundadoras",
        plan_name: "PRECIO FUNDADOR · OFERTA 2",
        old_price: "49,90€",
        price: "46,90€",
        period: "/mes durante 24 meses",
        features: [
          "Acceso a todas las instalaciones",
          "Abierto 365 días, 5:00h a 1:00h",
          "Sala climatizada",
          "Asesoramiento inicial gratuito",
          "Sin permanencia",
          "Precio bloqueado 24 meses",
        ],
        cta: "Reserva tu plaza fundadora",
        note: "Después de 24 meses, precio normal 49,90€/mes.",
        enrollment_label: "+ Matrícula gratis",
        enrollment_old: "29€",
        wa_msg: "¡Hola! Quiero reservar una plaza fundadora Oferta 2 en XPRO FITNESS (46,90€/mes durante 24 meses + matrícula gratis).",
      },
      founder_t3: {
        label: "🔥 Oferta 3 — Últimas 50 plazas fundadoras",
        plan_name: "PRECIO FUNDADOR · OFERTA 3",
        old_price: "49,90€",
        price: "46,90€",
        period: "/mes durante 24 meses",
        features: [
          "Acceso a todas las instalaciones",
          "Abierto 365 días, 5:00h a 1:00h",
          "Sala climatizada",
          "Asesoramiento inicial gratuito",
          "Sin permanencia",
          "Precio bloqueado 24 meses",
        ],
        cta: "Reserva tu plaza fundadora",
        note: "Después de 24 meses, precio normal 49,90€/mes.",
        enrollment_label: "+ Matrícula gratis",
        enrollment_old: "29€",
        wa_msg: "¡Hola! Quiero reservar una plaza fundadora Oferta 3 en XPRO FITNESS (46,90€/mes durante 24 meses + matrícula gratis).",
      },
      standard: {
        label: "Cuota estándar",
        plan_name: "CUOTA XPRO",
        price: "49,90€",
        period: "/mes",
        features: [
          "Acceso a todas las instalaciones",
          "Abierto 365 días, 5:00h a 1:00h",
          "Sala climatizada",
          "Asesoramiento inicial gratuito",
          "Sin permanencia",
        ],
        cta: "Reserva tu plaza",
      },
    },
    testimonials: {
      overline: "Comunidad XPRO",
      title: "Lo que dicen nuestros socios",
      items: [
        { name: "Marc P.", role: "Socio fundador", text: "Las máquinas son impecables y los entrenadores de primer nivel. El mejor gimnasio de Vidreres, de lejos." },
        { name: "Laia F.", role: "Grupo reducido", text: "Me encantan los entrenos en grupo reducido. Atención personalizada y con una energía brutal." },
        { name: "Jordi M.", role: "Entrenamiento personal", text: "Con el plan personal he ganado 6 kg de músculo en 4 meses. Gente muy profesional." },
      ],
    },
    location: {
      overline: "Dónde estamos",
      title: "Ven a conocernos",
      desc: "Te invitamos a una visita gratuita. Te mostramos las instalaciones sin compromiso.",
      address_line1: "Carrer Sils, 17",
      address_line2: "17411 Vidreres, Girona",
      phone: "+34 972 00 00 00 [PENDIENTE]",
      email: "hola@xprofitness.es",
      hours: "Lu — Do · 05:00 — 01:00 · 365 días",
      cta: "Escríbenos por WhatsApp",
    },
    faq: {
      overline: "Preguntas",
      title: "Dudas frecuentes",
      items: [
        { q: "¿Hay permanencia?", a: "No. La cuota es mensual, puedes darte de baja cuando quieras." },
        { q: "¿Puedo probar el gimnasio antes de apuntarme?", a: "Sí. Pásate sin compromiso y te mostramos las instalaciones." },
        { q: "¿Hay entrenador incluido?", a: "La cuota incluye asesoramiento inicial. El entrenamiento personal 1-a-1 es un servicio adicional." },
        { q: "¿Qué horarios tenéis?", a: "Abrimos todos los días de 5:00 a 1:00, 365 días al año. Incluidos fines de semana y festivos." },
        { q: "¿Qué son los entrenos en grupo reducido?", a: "Sesiones con un máximo de 6 personas, dirigidas por un entrenador. Tienes la energía del grupo con atención personalizada." },
      ],
    },
    footer: {
      tagline: "Tu gimnasio en Vidreres.",
      rights: "Todos los derechos reservados.",
      links: "Enlaces",
      legal: "Legal",
      terms: "Condiciones",
      privacy: "Privacidad",
      cookies: "Cookies",
      follow: "Síguenos",
    },
    whatsapp_msg: "¡Hola! Me gustaría reservar una plaza en XPRO FITNESS.",
    appDownload: {
      title: "¡Ya tenemos App!",
      subtitle: "Descarga la app de XPROFITNESS y accede al gimnasio, contrata servicios y gestiona tu plan desde el móvil. Pincha en cualquiera de estos dos enlaces para descargarla.",
    },
    banner: "Ya estamos abiertos · De 5:00h a 1:00h · 365 días al año · Sin festivos",
    reserve: {
      title: "Reserva tu plaza",
      subtitle: "Plaza limitada · Matrícula gratis · Sin permanencia",
      first_name: "Nombre",
      last_name: "Apellidos",
      email: "Email",
      phone: "Teléfono",
      dni: "DNI / NIE",
      birth_date: "Fecha de nacimiento",
      comments: "Comentarios (opcional)",
      accept_terms: "Acepto las condiciones y la política de privacidad",
      submit: "Reservar mi plaza",
      submitting: "Enviando...",
      success_title: "¡Plaza reservada!",
      success_text: (n) => `Tu plaza #${n} está reservada. Nos pondremos en contacto pronto.`,
      success_cta: "Cerrar",
      full_title: "Plazas agotadas",
      full_text: "No quedan plazas disponibles. Contáctanos por WhatsApp.",
      placeholders: {
        first_name: "Juan",
        last_name: "García Pérez",
        email: "juan@ejemplo.es",
        phone: "+34 600 000 000",
        dni: "12345678X",
        comments: "¿Alguna pregunta o necesidad especial?",
      },
      errors: {
        required: "Este campo es obligatorio",
        email: "Email no válido",
        phone: "Teléfono no válido",
        dni: "DNI / NIE no válido",
        terms: "Debes aceptar las condiciones",
      },
    },
  },
};

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    if (typeof window !== "undefined") {
      return localStorage.getItem("xpro_lang") || "ca";
    }
    return "ca";
  });
  const [bannerOpen, setBannerOpen] = useState(() => {
    if (typeof window !== "undefined") {
      return sessionStorage.getItem("xpro_banner_closed") !== "1";
    }
    return true;
  });

  useEffect(() => {
    localStorage.setItem("xpro_lang", lang);
    if (typeof document !== "undefined") {
      document.documentElement.lang = lang;
    }
  }, [lang]);

  const closeBanner = () => {
    setBannerOpen(false);
    if (typeof window !== "undefined") {
      sessionStorage.setItem("xpro_banner_closed", "1");
    }
  };

  const t = translations[lang];
  const toggle = () => setLang((l) => (l === "ca" ? "es" : "ca"));

  return (
    <LanguageContext.Provider value={{ lang, setLang, toggle, t, bannerOpen, closeBanner }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => useContext(LanguageContext);

export const WHATSAPP_NUMBER = "34604819692";
export const buildWhatsappLink = (msg) =>
  `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(msg)}`;

export const RESERVE_URL = "https://deporweb.deporweb.net/altaonline/nueva.aspx?header=true&footer=true&nav=false&lang=es-ES&type=WFBST0ZJVE5FU1N8NDY1#";
